export default String.raw`
.reportContent {
    &-popup {
        width: fit-content;
        padding: 0 32px 32px;

        .inputs-container-js {
            height: 500px;
            overflow: auto;
            padding-right: 24px;
        }
    }
}
`